import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import React, { Component } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { NavLink } from "react-router-dom";
import { Col, Row } from "reactstrap";
import FetchServerData from "../../../provider/FetchServerData";
import {
  ForgetPassword_Url,
  TenantList_Url,
} from "../../../provider/ServiceUrl";
import { withRouter } from "../../../withRouter";
import logo from "../../website/home/assets/img/givbeeLogo.png";
import PtsAlert from "../ptsAlert/PtsAlert";
import "./ForgotPassword.css";
import Utils from "../../../provider/Utils";

export class ForgotPassword extends Component {
  debounceTimeout = null;
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      tenantList: [],
      tenantId: "",
      isCompany: false,
      sendOtpByEmail: false,
      sendOtpByText: false,
      resetPasswordDisabled: true,
      error: false,
      render: false,
    };
  }

  getTenantList(email) {
    if (Utils.emailValidation(email)) {
      const postObject = {
        header: {
          userid: email,
        },
      };
      FetchServerData.callPostService(TenantList_Url, postObject).then(
        (output) => {
          if (output.status === "SUCCESS") {
            let tenantList = output.data;
            let tenantId = Utils.getArrayElement(tenantList, 0);
            if (tenantList.length > 1) {
              this.setState({
                email: this.state.email,
                tenantList: tenantList,
                tenantId: tenantId,
                isCompany: true,
                resetPasswordDisabled: false,
              });
            } else {
              this.setState({
                isCompany: false,
                tenantList: tenantList,
                tenantId: tenantId,
                resetPasswordDisabled: false,
              });
            }
          } else {
          }
        }
      );
    } else {
      if (email !== "" || email.length > 0) {
        PtsAlert.error("Enter valid User ID format john.doe@email.com");
      }
    }
  }

  handleEmailChange(e) {
    let val = e.target.value;
    this.setState({ email: val });
    // Clear previous timer
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }
    // Set new debounce timer
    this.debounceTimeout = setTimeout(() => {
      const domainRegex = /\.[a-zA-Z]{2,}$/;
      if (domainRegex.test(val)) {
        this.getTenantList(val);
      }
    }, 800);
  }

  handleCompanyChange(selectedValue) {
    this.setState({ tenantId: selectedValue });
  }
  forgotPasswordBackend() {
    // if (!this.state.sendOtpByEmail && !this.state.sendOtpByText) {
    //   this.setState({
    //     error: true,
    //   });
    //   return;
    // }
    let header = { email: this.state.email, tid: this.state.tenantId?.id };
    const postObject = {
      header: header,
      appuser: {
        email: this.state.email,
        // sendOtpByEmail: this.state.sendOtpByEmail,
        // sendOtpByText: this.state.sendOtpByText,
      },
    };

    FetchServerData.callPostService(ForgetPassword_Url, postObject)
      .then((response) => {
        let output = response;
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          this.props.navigate("/resetPassword", {
            state: {
              email: this.state.email,
              tenantId: this.state.tenantId,
              tenantList: this.state.tenantList,
            },
          });
        } else {
          if (output.status === "FAIL") {
            PtsAlert.error("Please enter Registered User Id");
          }
        }
      })
      .catch((error) => { });
  }

  handleSendOtpByEmailChange(e) {
    this.setState({ sendOtpByEmail: e.target.checked, error: false });
  }
  handleSendOtpByTextChange(e) {
    this.setState({ sendOtpByText: e.target.checked, error: false });
  }

  render() {
    return (
      <div className="authentication-wrapper authentication-cover">
        <div className="authentication-inner row m-0" id="signIn">
          <div
            className="d-flex col-12 col-lg-6 col-xl-6 align-items-center leftBackground"
            style={{ textAlign: "center", background: "rgb(55, 81, 126)" }}
          >
            <div className="mx-auto">
              <div className="logoBackground">
                <img
                  src={logo}
                  className="img-fluid logoImage"
                  alt=""
                  data-app-dark-img="illustrations/girl-with-laptop-dark.png"
                  data-app-light-img="illustrations/girl-with-laptop-light.png"
                />
              </div>
            </div>
          </div>
          <div className="d-flex col-12 col-lg-6 col-xl-6 align-items-center authentication-bg p-sm-5 p-4">
            <div className="w-px-400 mx-auto">
              <Row>
                <Col md={12} className="forgotPasswordSubTitle">
                  <h4>Forgot Password?</h4>
                  <p>
                    To be sent a reset-password link and verification code, please enter your User ID and click the button.
                  </p>
                </Col>
              </Row>
              <ValidatorForm
                ref="form"
                className="mb-3"
                onSubmit={this.forgotPasswordBackend.bind(this)}
              >
                <div className="mb-3">
                  <label className="form-label" htmlFor="multiStepsEmail">
                    User ID
                  </label>
                  <input
                    title=""
                    required
                    type="email"
                    name="multiStepsEmail"
                    value={this.state.email}
                    onChange={this.handleEmailChange.bind(this)}
                    id="multiStepsEmail"
                    className="form-control"
                    aria-label="john.doe"
                  />{" "}
                </div>
                {this.state.isCompany && (
                  <div className="mb-3">
                    <label
                      className="form-label"
                      htmlFor="multiStepsLastName"
                    >
                      Company Name
                    </label>

                    <Autocomplete
                      id="size-small-outlined"
                      size="small"
                      fullWidth
                      disableClearable
                      autoComplete="off"
                      ListboxProps={{
                        className: "custom-listbox",
                      }}
                      options={this.state.tenantList}
                      value={this.state.tenantId}
                      getOptionLabel={(option) => option.name}
                      defaultValue={this.state.tenantId}
                      onChange={(event, value) => {
                        this.handleCompanyChange(value);
                      }}
                      inputprops={{
                        style: { textTransform: "capitalize" },
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Please Select"
                          variant="outlined"
                          size="small"
                          style={{ background: "#fff" }}
                        />
                      )}
                    />
                  </div>
                )}
                {/* <div className="row mb-3 d-flex">
                    <label className="form-label" htmlFor="multiStepsPass">
                      Send verification code to my:
                    </label>
                    <div className="col-md-3 d-flex">
                      <span className="me-3" style={{ marginTop: "2px" }}>
                        <input
                          type="checkbox"
                          style={{ cursor: "pointer" }}
                          value={this.state.sendOtpByText}
                          onChange={(e) => this.handleSendOtpByTextChange(e)}
                          checked={this.state.sendOtpByText}
                        />
                      </span>
                      <p className="form-label " htmlFor="collapsible-lastname">
                        Mobile
                      </p>
                    </div>
                    <div className="col-md-3 d-flex">
                      <span className="me-3" style={{ marginTop: "2px" }}>
                        <input
                          type="checkbox"
                          style={{ cursor: "pointer" }}
                          value={this.state.sendOtpByEmail}
                          onChange={(e) => this.handleSendOtpByEmailChange(e)}
                          checked={this.state.sendOtpByEmail}
                        />
                      </span>
                      <p className="form-label " htmlFor="collapsible-lastname">
                        Email
                      </p>
                    </div>

                    {this.state.error ? (
                      <lable className="danger" style={{ color: "red" }}>
                        Please Select checkbox
                      </lable>
                    ) : (
                      ""
                    )}
                  </div> */}
                <button
                  type="submit"
                  className="goButton d-grid w-100 mt-4"
                  disabled={this.state.resetPasswordDisabled}
                >
                  Reset My Password
                </button>
              </ValidatorForm>
              <div style={{ textAlign: "left" }}>
                <NavLink to="/signin">
                  <ArrowBackIosNewIcon />
                  Back
                </NavLink>
                &nbsp;&nbsp;
              </div>
            </div>
          </div>
        </div >
      </div >
    );
  }
}

export default withRouter(ForgotPassword);
